import React from 'react'

import {
  getQS,
} from 'helpers'

import { SiteContext } from 'context/site-context'

import './index.scss'

const PriorityListing = ( { listing = null } ) => {
  const [ site ] = React.useContext(SiteContext)

  const getProfileUrl = () => {
    const qs = getQS().trim().length > 0 ? `?${getQS()}` : ''
    return `${window.location.origin}/${site.path ? `${site.path}/` : ''}profile/${listing.listingId}${qs}`
  }

  return <React.Fragment>
    {listing ? <div className="priority-listing-container">
      <label>Featured business</label>
      <a href={getProfileUrl()}  className="priority-listing">
        <div className="details-container">
          <h2>{listing.name}</h2>
          {listing.tagline && <div className="tagline">{listing.tagline}</div>}
        </div>
        <div className="image-container">{listing.ad_image_url && <img src={listing.ad_image_url} alt={listing.name} />}</div>
      </a>
    </div> : null}
  </React.Fragment>
}

export default PriorityListing
